/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

class TimeBlock extends Component {
  _goItem = (contentSerial) => {
    const { setContentSerial } = this.props;
    setContentSerial(contentSerial);
    //setUpdateShow(false)
    //history.push('/items/' + contentSerial)
  };
  _onItems = (contentSerial) => {
    const { setContentSerial } = this.props;
    setContentSerial(contentSerial);
  };
  _renderItem = () => {
    const { timeItems } = this.props.childProps;

    const list = timeItems.map((item, index) => {
      // let mm;
      // if (item.mm === 0) {
      //   mm = "00";
      // } else {
      //   mm = item.mm;
      // }
      return (
        <div key={index} className={"time_box2"}>
          <dl>
            {/*<dt>{mm}분</dt>*/}
            <dd style={{ whiteSpace: "pre-wrap" }}>
              <img
                src={item.img}
                style={{ cursor: "pointer" }}
                onClick={() => this._onItems(item.contentSerial)}
              />
              <p
                style={{ cursor: "pointer" }}
                onClick={() => this._onItems(item.contentSerial)}
              >
                {item.title}
              </p>
              <div
                style={{ cursor: "pointer" }}
                onClick={() => this._onItems(item.contentSerial)}
              >
                {item.subTitle}
              </div>
              <div>
                {item.restrictionCode === 19 ? (
                  <em>{item.restrictionCode}</em>
                ) : null}
              </div>
            </dd>
          </dl>
        </div>

        /*
                <div style={{ paddingLeft: 10}}>
                    {item.mm}분 {item.subTitle}
                </div>
                */
      );
    });

    return list;
  };

  render() {
    const { timeItems } = this.props.childProps;
    return (
      <Fragment>
        {timeItems.length > 0 ? (
          this._renderItem()
        ) : (
          <div style={{ color: "#ffffff", textAlign: "center" }}>
            준비중입니다.
          </div>
        )}

        {/*
                <div style={{ paddingLeft: 10}}>
                    00분 던전에서.. 11화
                </div>
                <div style={{ paddingLeft: 10}}>
                    30분 던전에서.. 11화
                </div>
                */}
        {/*            
                <ToastContainer 
                    position="bottom-right"
                    hideProgressBar
                />
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(TimeBlock));
